import * as Html from "../../util/Html.ts";

export {initDom}

function initDom(obj: HTMLElement){
  obj.style.display = 'inline-block';
  obj.style.transformOrigin = "left";
  fitIt(obj);
}

function fitIt(obj: HTMLElement){
  const parent = obj.parentElement;
  if(!parent) return;

  const ratio = 0.9 * parent.offsetWidth / obj.offsetWidth;
  if(ratio < 1){
    obj.style.transform = `scale(${ratio})`;
  }
}

Html.registerWidget('widget/animation/autofit',{initDom:initDom})